import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { connect, ConnectedProps, useDispatch, useStore } from 'react-redux';
import { Dispatch } from 'redux';
import {
  setAdriverSelectedCity,
  setChosenLocationNames,
  setCurrentCity,
  setCurrentState,
  setError,
  setLocationIds
} from '../../../actions';
import { GeneralAdsPage } from '../../GeneralAdsPage';
import { BUILDING_TYPE_ID, Cities } from '../../../utils/helpers/constants';
import { CategoriesQuery } from '../../../graphql/graphql';
import { BreadcrumbI } from '../../Breadcrumbs';
import { setCurrentFiltersToStore } from '../../../utils/helpers/search';
import { getDataForTransformationsQuery } from '../../../api/queries/searchQueries';

interface SearchPageProps {
  transformedObj: {
    filter: { [key: string]: string | boolean };
    sorting?: string;
  };
  isCategoryTouched?: boolean;
  chosenLocationNames?: string[];
  totalAdsCount?: number;
  h1?: string;
  categories: CategoriesQuery['categories'];
  breadcrumbs: BreadcrumbI[];
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
});

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type CombinedProps = SearchPageProps & PropsFromRedux;

const SearchPageComponent: React.FC<CombinedProps> = ({
  transformedObj,
  isCategoryTouched,
  chosenLocationNames,
  setErrorUI,
  totalAdsCount,
  h1,
  categories,
  breadcrumbs
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const formEl = useRef(null);

  const store = useStore();
  const transformData = useQuery(getDataForTransformationsQuery, {
    fetchPolicy: 'cache-only',
    ssr: false
  });

  useEffect(() => {
    if (!transformedObj?.filter || !transformData.data) return;
    const transformedObjForStore = {
      ...transformedObj,
      filter: { ...transformedObj.filter, category_touched: isCategoryTouched }
    };
    setCurrentFiltersToStore(transformedObjForStore, store, transformData);
    dispatch(setChosenLocationNames(chosenLocationNames || []));
  }, [transformedObj, transformData.data, isCategoryTouched]);

  useEffect(
    () => () => {
      setErrorUI(false);
    },
    []
  );

  const resetForm = () => {
    const resetData = {
      city_id: Cities.Baku.id,
      leased: 'false',
      category_id: BUILDING_TYPE_ID.FLAT_ALL
    };
    formEl?.current?.reset(resetData);
    dispatch(setChosenLocationNames([]));
    dispatch(setLocationIds([]));
    dispatch(setCurrentCity(Cities.Baku.id));
    dispatch(setCurrentState({ ...resetData, category_touched: false }));
    dispatch(setAdriverSelectedCity(Cities.Baku.az));

    router.push('/');
  };

  return (
    <GeneralAdsPage
      {...{
        transformedObj,
        setErrorUI,
        h1,
        resetForm,
        totalAdsCount,
        categories,
        breadcrumbs
      }}
      ref={formEl}
    />
  );
};

export const SearchPage = connector(SearchPageComponent);
